//export const url = 'http://localhost/ojekOnly/';
//export const homePage = 'http://localhost:8080';
//export const homePage = 'http://blonjo.web.id/kulinerMajangan/admin/';
export const homePage = 'http://beatcom.web.id';
export const title = '';
export const tNama = 'Beatcom RTRW';
export const tNick = 'RTRW';
export const Versi = 'v.8.1.0';
export const tAlamat = 'Jl Kolonel Suwandi';
export const tAlamatAncer2 = '(Pertokoan Hotel Agung No. 6)';
export const tWA = 'WA -';

// DEV

/*

export const conlog = true;
export const loginFor = "beatcom"; 
export const url = "http://localhost/tagihan/8.1.0";
export const urlAssets = "http://localhost/tagihan/images/";
export const urlSocket2 = "http://localhost:8001";
export const urlMikrotik = "http://localhost/ROUTEROS/praktek/";
export const urlAbsensi = "http://localhost/absensi/2.0.0";
export const urlBelog = "http://localhost/Belog";
//export const urlForumAssets = "http://localhost/forum_rtrw/";
export const urlSocket = "http://localhost:8001";
export const urlSlider = "http://localhost/tagihan_user_assets/";
export const urlSliderAssets = "http://localhost/tagihan_user_assets/images/slider/";
export const linkWebPelanggan = "https://localhost:8080";

*/


// BUILD 
// BEATCOM NETWORK

/*

export const conlog = false;
export const loginFor = "beatcom"; 

//export const url = "https://blonjo.web.id/beat/API/WIFI/"+Versi;
export const url = "https://akulelah.web.id/_api/owner/"+Versi;

//export const url = "https://bejek.web.id/network/"+Versi;
//export const urlAssets = "https://blonjo.web.id/beat/API/WIFI/images/";

export const urlAssets = "https://akulelah.web.id/assets/images/";

///// SOCKET
export const urlSocket = "http://103.150.93.152:8080/"; // 8000 fix // 8080 dev
//export const urlMikrotik = "https://blonjo.web.id/beat/API/WIFI/mikrotik/";
export const urlMikrotik = "http://103.196.155.61/mikrotik";
export const urlForum = "https://beatcom.web.id/forum_rtrw/v.1.0.0";
export const urlForumAssets = "https://beatcom.web.id/forum_rtrw/";
export const urlSlider = "https://beatcom.web.id/tagihan_user_assets/";
export const urlSliderAssets = "https://beatcom.web.id/tagihan_user_assets/images/slider/";

export const urlAbsensi = "https://beatcom.web.id/absensi/2.0.0";
export const urlBelog = "https://beatcom.web.id/belog";
export const linkWebPelanggan = "https://mywifi.beatcom.web.id";


*/

// BUILD 
// APLIKABET

export const conlog = false;
export const loginFor = "aplikabeat";
export const VersiAplikabeat = 'v.8.1.0';

export const url = "https://malesdev.com/_api/owner/"+VersiAplikabeat;
export const urlAssets = "https://malesdev.com/_api/owner/assets/images/";
export const urlSocket = "http://103.150.93.152:8080/"; // 8000 fix // 8080 dev
export const urlMikrotik = "http://103.196.155.61/mikrotik";
export const urlSlider = "https:///malesdev.com/_api/owner/tagihan_user_assets/";
export const urlSliderAssets = "https:///malesdev.com/_api/owner/tagihan_user_assets/images/slider/";

export const urlAbsensi = "https://malesdev.com/_api/owner/absensi/2.0.0";
export const urlBelog = "https://malesdev.com/_api/owner/belog";

export const urlForum = "https://beatcom.web.id/forum_rtrw/v.1.0.0";
export const urlForumAssets = "https://beatcom.web.id/forum_rtrw/";

export const linkWebPelanggan = "https://aplikabeat.com";

// export const urlSocket = "http://localhost:8001";


// WEBPACK FOOTER //
// ./src/var/var.js